import type { ReactNode } from "react"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"

interface SiteHeaderProps {
  title?: string
  action?: ReactNode
}

export function SiteHeader({ title, action }: SiteHeaderProps) {
  return (
    <header className="hidden md:flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        {title && <h1 className="text-base font-medium">{title}</h1>}
        {action && <div className="ml-auto flex items-center">{action}</div>}
      </div>
    </header>
  )
}
